import { useEffect, useState } from 'react'

export type TPropsUseWaitStatus =
  | {
      isDefaultWaiting?: boolean
      timeout?: number
    }
  | undefined

function useWaitingStatus({ isDefaultWaiting = false, timeout = 1500 }: TPropsUseWaitStatus = {}) {
  const [isWaiting, setIsWaiting] = useState(isDefaultWaiting)

  useEffect(() => {
    if (isWaiting) {
      const t = setTimeout(() => {
        setIsWaiting(false)
      }, timeout)
      return () => clearTimeout(t)
    }
    return undefined
  }, [isWaiting, timeout])

  return {
    isWaiting,
    setIsWaiting
  }
}

export default useWaitingStatus
